<template>
    <div class="card">
        <div class="card-image">
            <figure class="image is-4by3">
                <img src="https://bulma.io/images/placeholders/1280x960.png" alt="Placeholder image">
            </figure>
        </div>
        <div class="card-content">
            <div class="content is-capitalized">
                MISIÓN ÁGAPE - PROGRAMA EN
                <br>
                VIVO 2019 - PROGRAMA 27
            </div>
            <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoCard'
}
</script>

<style>
    .card {
        box-shadow: none;
        background-color: #F2F2F2;
    }
</style>